import gql from 'graphql-tag'

import { IContentFeed } from '../queries/getContentFeeds'

export interface IUpsertContentFeedVariables {
  /** Omit to create. */
  id?: string
  name: string
  description?: string | null
  displayOrder?: number | null
  enabled?: boolean
}

export interface IUpsertContentFeedResponse {
  upsertContentFeed: IContentFeed
}

/**
 * One document serves create, enable/disable and reorder. `name` is required on
 * every call server-side, so a toggle or a reorder has to resend the feed's
 * current name.
 *
 * The full field set is selected back deliberately: Apollo normalises the
 * result by id, so an edited row updates in cache with no refetch.
 */
export const upsertContentFeedMutation = gql`
  mutation upsertContentFeed(
    $id: String
    $name: String!
    $description: String
    $displayOrder: Int
    $enabled: Boolean
  ) {
    upsertContentFeed(
      id: $id
      name: $name
      description: $description
      displayOrder: $displayOrder
      enabled: $enabled
    ) {
      id
      name
      slug
      description
      displayOrder
      enabled
      topics {
        id
        name
      }
    }
  }
`

export default upsertContentFeedMutation
